import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { setTokenGetter } from "services/token-provider";

export const getAudience = () => {
  return window.location.hostname === "beta.lynx-esg.com" ||
    window.location.hostname === "demo.lynx-esg.com"
    ? "https://lynx-api-demo.com"
    : window.location.hostname === "lynx-esg.com" ||
        window.location.hostname === "staging.lynx-esg.com"
      ? "https://lynx-api-prod.com"
      : "https://lynx-api-dev.com";
};

const AuthBootstrap = () => {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();
  const isOffline = !navigator.onLine;
  useEffect(() => {
    if (isAuthenticated && !isLoading && !isOffline) {
      setTokenGetter(() =>
        getAccessTokenSilently({
          audience: getAudience(),
        })
      );
    }
  }, [getAccessTokenSilently, isAuthenticated, isLoading, isOffline]);

  return null;
};

export default AuthBootstrap;
